import { FC } from "react";
import { Button } from "antd";
import type { ResolvedFlow } from "../constants";

export const FailureBanner: FC<{ flow: ResolvedFlow }> = ({ flow }) => {
  return (
    <div className="fixed inset-0 w-full z-50 flex items-center justify-center bg-background-inverted/40">
      <div className={`relative w-96 max-w-96 flex w-full flex-col gap-2 rounded-lg p-6 shadow-sm ${flow.className ?? ""}`}>
        <div className="mb-4 h-16 w-16">{flow.icon}</div>
        <h2 className="mb-1 text-lg font-bold text-font-default">{flow.failReason}</h2>
        <div className="flex flex-col gap-2">
          <p className="text-sm text-font-subtle">{flow.suggestion}</p>
          <p className="text-sm text-font-subtle">{flow?.info}</p>
        </div>
        <div className="flex flex-col gap-2">
          {flow.buttons.map((btn) => (
            <Button
              key={btn.title}
              onClick={btn.onClick}
              loading={btn.loading}
              iconPlacement="end"
              disabled={btn.loading}
              className={`w-full! cursor-pointer! rounded-lg! px-4! py-4! text-sm! transition! border-none! shadow-none! h-auto! ${btn.className ?? ""}`}
              classNames={{ content: "flex! items-center! justify-center!" }}
            >
              {btn.title}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
